import { status, StatusType, StatusTypeErrorNumber } from '../../typeStatus'
import {
  CartReset,
  CartValorized,
  CartValorizedError,
  CartValorizedSuccess,
} from './interface-transactional-actions/cartValorized'

import {
  GetCartCache,
  GetCartCacheError,
  GetCartCacheReset,
  GetCartCacheSuccess,
} from './interface-transactional-actions/getCart'

/** -- valores extra necesarios, en este caso mejorar la transicion de estados
 * de cara al cliente  -- */
export const UPDATE_PARAMS_CART = 'UPDATE_PARAMS_CART'
export interface StyledItem {
  type: string
  icon: string
  label: string
  creditos: number | null
  color: string
}

/**
 * @DataProduct productId y quantity, DATA PARA VALORIZAR
 */
export interface DataProduct {
  productId: number
  quantity: number
  unitPrice: number
}

export interface TotalAmounts {
  totalTaxedAmount: number
  totalNonTaxedAmount: number
  taxIva: number
  taxIngresoBruto: number
  totalQuantityItems: number
  totalDiscount: number
}
export interface DataValorizedDTO extends TotalAmounts {
  items: DataProduct[]
}

export interface Params {
  idProductSelected: number | null
  idProductRemoved: boolean
}

export interface ItemCart {
  dataProduct: DataProduct
  styled: StyledItem
}

export interface CartProducts extends TotalAmounts {
  items: ItemCart[]
}

/**
 * @ExtraParams data adicional para valorizar, por ahora cupon.
 */

export interface ExtraParams {
  couponCode: string | null
}

export const InitialStateItemsCart = {
  totalTaxedAmount: 0,
  totalNonTaxedAmount: 0,
  taxIva: 0,
  taxIngresoBruto: 0,
  items: [],
  totalQuantityItems: 0,
  totalDiscount: 0,
}
export interface ValorizedCartState {
  statusCart: StatusTypeErrorNumber
  cart: CartProducts
  params: Params
  statusCacheCart: StatusType
}

const InitialStateParams = {
  idProductSelected: null,
  idProductRemoved: false,
}

export const InitialState: ValorizedCartState = {
  cart: InitialStateItemsCart,
  statusCart: status.initial,
  params: InitialStateParams,
  statusCacheCart: status.initial,
}

export interface UpdateParamsCart {
  type: typeof UPDATE_PARAMS_CART
  payload: Params
}

export type CartActions =
  | CartValorized
  | CartReset
  | CartValorizedSuccess
  | CartValorizedError
  | GetCartCache
  | GetCartCacheError
  | GetCartCacheSuccess
  | UpdateParamsCart
  | GetCartCacheReset
